import { map } from 'lodash';
import { store as themeStore } from "pages/Thematique/store";
import { defineStore, StoreDefinition } from 'pinia';
import { pinia } from 'plugins/store/index';
import { computed, ref } from 'vue';

declare global {
  interface Window {
    __GLOBALS:Globals
  }
}
interface Globals {
  navigations: O<Obj>,
  themes : ThemeItemCTA[]
}

const data = window.__GLOBALS ?? {
  navigations: undefined,
}

const api = window.__GLOBALS ? undefined : {
  url: 'globals',
  moc: true,
  getMoc(){
    return import(  `./moc/fr` )
  }
}

interface App extends Obj {
  ready: boolean,
  api?: ApiRequestConfig,
  data: Globals,
  messages: any,
}

const useStore: StoreDefinition = defineStore('globalsKffein', () => {
  const state = ref<App>({
    ready: false,
    api,
    data,
    messages: undefined,
  })

  // Actions
  const LOAD = async (locale: string, skip?: boolean):Promise<any> => {
    if (!locale) return null;

    const request = new Promise(resolve=>{
      if(window.__GLOBALS || !state.value.api){
        return resolve(window.__GLOBALS)
      }
      
      const payload = { ...state.value.api }
      if(skip) payload.moc = true
      // async import because use i18n and i18n use this - storybook dev would bug
      const req = import('plugins/api').then(m=>m.default)
      .then(ApiHelper=> ApiHelper.get(payload)
      .then(({ data }: any) => {
        state.value.data = data;
        return data
      })
      )
      return resolve(req)
    })
    
    request
      .then(({ i18n }: any) => {
        if (!i18n) return;
        themeStore.init(map(state.value.data.themes, (item) => item as any));
        
        state.value.messages = {...i18n};
        state.value.ready = true; 
      })

    return request; 
  }

  return {
    state,

    //getters
    themes: computed( () => state.value.data.themes),
    navigations: computed( () => state.value.data.navigations),
    messages: computed( () => state.value.messages),
    ready: computed( () => state.value.ready),
    
    //actions
    LOAD,
  }
});

export const store = useStore(pinia) as ReturnType<typeof useStore>;
export default store;
